/// <reference path="../types/less.d.ts" />
/// <reference path="../types/jsx.d.ts" />
// #region Core & Configuration
import { BnumConfigOptions } from '../core/utils/constants/config';
import { BnumConfig } from '../core/utils/BnumConfig';
import BnumElement from '../components/bnum-element';
import Log from '../core/utils/Log';
import RotomecaDocument, {
	RotomecaCssProperty,
	RotomecaCssRule,
} from '@rotomeca/document-utils';

// Barrel Exports (Générés par le script)
export * from '../components/atoms';
export * from '../components/molecules';
export * from '../components/organisms';
export * from '../components/template';

//#endregion Core & Configuration

// #region Global Initialization
declare global {
	interface Window {
		DsBnumConfig?: Partial<BnumConfigOptions>;
	}
}

if (typeof window !== 'undefined' && window.DsBnumConfig) {
	BnumConfig.Initialize(window.DsBnumConfig).tapError(error => {
		Log.error(
			'design-system-bnum',
			"Erreur lors de l'initialisation de la configuration globale :",
			error,
		);
	});
}
// #endregion Global Initialization

// Exports manuels spécifiques
export {
	BnumConfig as Config,
	BnumElement,
	RotomecaDocument as DsDocument,
	RotomecaCssProperty as DsCssProperty,
	RotomecaCssRule as DsCssRule,
};
